import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IGoldenRaceGetUrl, IGoldenRaceServerGame } from '../../types/interfaces/Slots/GoldenRace';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';
import { getTab } from './utils';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IGoldenRaceServerGame[]>): ISlotViewItem[] =>
    (data ?? [])
      .filter(item => item.provider.toUpperCase() !== 'TVBET')
      .map(
        item =>
          ({
            id: String(item.gameId),
            gameId: String(item.gameId),
            description: item.gameTitle,
            gameName: item.gameTitle,
            tab: getTab(item.gameFriendlyName),
            provider: 'goldenRace',
            imageUrl: item.thumbnail,
            routeProvider: 'goldenRace',
            type: CasinoType.virtualGames,
          }) as ISlotViewItem,
      );

  convertGameUrl = ({ data }: IGetGameUrl<IGoldenRaceGetUrl, unknown>) => data.url;
}

export default Converter;
